<template>
  <main class="main-content d-flex justify-content-center align-items-start p-4 overflow-auto mt-6"
    style="background-color: #f8f9fa;">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-10">
          <button class="btn-white btn-text mb-4" @click="$router.push({ name: 'Home' })">
            <i class="fas fa-chevron-left" style="margin-right: 10px;" aria-hidden="true"></i> 
            Back to Home</button>  
          <h5 class="text-head mb-2">Profile</h5>
          <!-- Detail Information Form Card -->
          <div class="card border-0 mb-4">
            <div class="card-body">
              <div class="mb-4">
                <!-- Nav pills to load components dynamically -->
                <div class="d-inline-flex">
                  <ul class="nav nav-pills">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'DetailInformation' }" @click="activeTab = 'DetailInformation'">Detail Information</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'Documents' }" @click="activeTab = 'Documents'">Documents</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'ChangePassword' }" @click="activeTab = 'ChangePassword'">Change Password</a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Dynamic Component Rendering -->
              <component :is="activeTabComponent" :data="data || {}" />
              <div class="text-center mt-4">
                <small class="text-muted">© PT Anugrah Multi Remittance 2025 | <a href="#" class="text-decoration-none text-muted">Terms & Conditions</a> | <a href="#" class="text-decoration-none text-muted">Privacy Policy</a></small>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <Loading :isLoading="isLoading" />
</template>

<script>
import { ref, computed, onMounted, onBeforeMount, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import Loading from "@/components/Loading";
import ArgonInput from "@/components/ArgonInput";
import { getProfile } from "../../api/company";
import DetailInformation from "@/views/profile/CompanyDetail.vue";
import Documents from "@/views/profile/Document.vue";
import ChangePassword from "@/views/profile/ChangePassword.vue";

export default {
  components: {
    ArgonInput, Loading, DetailInformation, Documents, ChangePassword
  },
  setup() {
    const store = useStore();
    const merchantId = ref(localStorage.getItem("merchantId") || 0);
    const companyName = ref(localStorage.getItem("merchantName") || '');
    const data = ref(null);
    const activeTab = ref("DetailInformation");
    const isLoading = ref(false);

    const activeTabComponent = computed(() => {
      switch(activeTab.value) {
        case "DetailInformation":
          return DetailInformation;
        case "Documents":
          return Documents;
        case "ChangePassword":
          return ChangePassword;
        default:
          return DetailInformation;
      }
    });

    const fetchProfile = async () => {
      isLoading.value = true;
      try {
        const response = await getProfile(merchantId.value);
        if (response.status === 'success') {
          data.value = response.data.merchant;
        } else {
          console.error("Error fetching profile data:", response);
        }
      } catch (error) {
        console.error("Exception when fetching profile:", error);
      } finally {
        isLoading.value = false;
      }
    };

    onBeforeMount(() => {
      const body = document.getElementsByTagName("body")[0];
      store.state.hideConfigButton = true;
      store.state.showSidenav = false;
      store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
    });

    onBeforeUnmount(() => {
      const body = document.getElementsByTagName("body")[0];
      store.state.hideConfigButton = false;
      store.state.showSidenav = true;
      store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    });

    onMounted(() => {
      fetchProfile();
    });

    return {
      merchantId,
      companyName,
      data,
      activeTab,
      activeTabComponent,
      isLoading
    };
  }
}
</script>

<style scoped>
.main-content {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.text-head{
  font-family: "IBM Plex Sans Devanagari";
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}

.card {
  border-radius: 0.5rem;
}

.card-header {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}

.nav {
  border-radius: 50px !important;  
}

.nav-pills {
  display: flex;
  justify-content: center;
}

.nav-pills .nav-item {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.nav-pills .nav-link {
  font-family: "IBM Plex Sans Devanagari";
  font-size: 14px;
  font-weight: 400;
  color: #6c757d;
  background-color: transparent;
  text-align: center;
  padding: 0.5rem 1rem;
  white-space: nowrap;
}

.nav-pills .nav-link.active {
  color: #212529;
  background-color: #fff;
  border-radius: 50px;
  margin: 5px;
}

.id-preview img:hover {
  opacity: 0.8;
}
</style>